import { render } from "./IncomeProtectionPolicyDetails.vue?vue&type=template&id=45204844&scoped=true"
import script from "./IncomeProtectionPolicyDetails.vue?vue&type=script&lang=js"
export * from "./IncomeProtectionPolicyDetails.vue?vue&type=script&lang=js"

import "./IncomeProtectionPolicyDetails.vue?vue&type=style&index=0&id=45204844&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45204844"]])

export default __exports__